// extracted by mini-css-extract-plugin
module.exports = {"logo":"menu_logo__2ga0N","menu":"menu_menu__3SdoD","nav":"menu_nav__33l56","isScrolled":"menu_isScrolled__1FPuS","left":"menu_left__PSBH2","right":"menu_right__3x8A1"};